import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './ContractSearchPage.scss';

const ContractListingRow = props => {
    let data = props.data;
	return (<>
        <div className={'contract-list-item-holder'} onClick={() => {props.onClick(data)}}>
        <div className={'contract-list-item'}>
            <div className={'contract-list-item-info'}>
                <div className={'contract-list-item-name'}>{data.companyName}</div>
                <div className={'contract-list-item-address'}>
                    <div className={'contract-list-item-area'}>{data.area+" - "+data.city}</div>
                </div>
                <div className={'contract-list-item-docid'}>{data.docId}</div>
            </div>
            <div className={'contract-list-item-iconHolder'}>
                <span className={' icon-pagination-down'}></span>
            </div>
            </div>
        </div>
    </>);
};

const mapStateToProps = state => {
	return {
		...state
	};
};

export default connect(mapStateToProps,{})(ContractListingRow);